import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGreenPower: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGreenPower"><Path d="M13.5 7L9 12.5H11.5V16L16 10.5H13.5V7Z" fill="currentColor"/><Path d="M3.49981 20.4911L5.98587 18.005M5.98587 18.005C-0.744158 9.88113 6.68286 0.332215 19.9453 4.04568C23.6586 17.3081 14.1097 24.735 5.98587 18.005Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGreenPower;
